"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Paper_1 = require("./Paper");
exports.default = Paper_1.default;
//# sourceMappingURL=index.js.map